export default __webpack_public_path__ + "static/media/lewc_logo.97ca555d.png";